
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/get-free-samples",
      function () {
        return require("private-next-pages/get-free-samples.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/get-free-samples"])
      });
    }
  